import { useParams } from "react-router-dom";
import { CollectionDetails } from "@/app/modules/CollectionDetails";

export const Collection = () => {
  const { id } = useParams();
  return <CollectionDetails id={parseInt(id ?? "")} />;
};
